import { render, staticRenderFns } from "./RouteAlive.vue?vue&type=template&id=4652811c"
import script from "./RouteAlive.vue?vue&type=script&lang=js"
export * from "./RouteAlive.vue?vue&type=script&lang=js"
import style0 from "./RouteAlive.vue?vue&type=style&index=0&id=4652811c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports